import { Injectable } from '@angular/core';
import { FLAGS } from './services/flags.service';
import { FlagsService } from './services/flags.service';

@Injectable({
  providedIn: 'root',
})
export class ConstantMemoryApiSpaceSyncSettingsService {
  constructor(private flagsService: FlagsService) {}

  get shouldSendUpdatesBasedOnDocChanges(): boolean {
    return (
      this.flagsService.isFlagEnabled(FLAGS.CONSTANT_MEMORY_API_SPACE_SYNC_SETTINGS) &&
      !!this.flagsService.featureFlagsVariables[FLAGS.CONSTANT_MEMORY_API_SPACE_SYNC_SETTINGS]
        .send_updates_based_on_doc_changes
    );
  }

  get skipFullSyncThresholdOnFirstLoad(): number {
    return (
      (this.flagsService.featureFlagsVariables[FLAGS.CONSTANT_MEMORY_API_SPACE_SYNC_SETTINGS]
        ?.skip_full_sync_threshold_on_first_load as number) || 50
    );
  }
}
